export const isEmpty = (obj) => {
  function isObjectEmpty(obj) {
    if (typeof obj !== 'object') return false;

    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  return obj === null || obj === undefined || obj === '' || obj.toString().trim() === '' || isObjectEmpty(obj);
};

export const objectWithoutProperties = (obj, keys): any => {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
};

export const getMaskFromPhoneNumber = (cellphone: string): string => {
  let startContact;

  if (cellphone && cellphone.startsWith('0')) {
    startContact = cellphone;
  } else {
    startContact = `0${cellphone.substring(2)}`;
  }

  if (startContact.startsWith('0800')) {
    return '0000 000 0000';
  } else {
    return '(00) 0000-0000||(00) 0 0000-0000';
  }
};

export function phoneMaskNoBRPrefix(maskService: any, phone: string): any {
  if (/[a-zA-Z]/.test(phone) || phone.length < 8) {
    return phone;
  }

  let result = (phone ?? ``).trim();

  const hasZeroBeforeDDD = result.match(/^0(\d{2})(\d+)$/) && !result.startsWith('0800');
  const hasZeroBetween55AndDDD = result.match(/^550(\d{2})(\d+)$/) && !result.startsWith('55080');
  const is0800BRPrefixedWith55 = result.length === 12 && result.startsWith(`55800`);
  const is0800BRPrefixed = result.length === 10 && result.startsWith(`800`);

  if (hasZeroBeforeDDD) {
    const match = result.match(/^0(\d{2})(\d+)$/);
    if (match) {
      const ddd = match[1];
      const number = match[2];
      result = `55${ddd}${number}`;
    }
    result = phoneMask(maskService, result);
  } else if (hasZeroBetween55AndDDD) {
    result = '55' + result.substring(3);
    result = phoneMask(maskService, result);
  } else if (is0800BRPrefixedWith55) {
    result = phoneMask(maskService, `550` + result.substring(2, result.length));
  } else if (is0800BRPrefixed) {
    result = phoneMask(maskService, `550` + result);
  } else {
    if (result.length === 11 && !result.startsWith('55')) {
      //DDD{2}+{CELLPHONE}{9}
      result = '55' + result; //assume is BR
    }
    if (result.match(/^055/)) {
      result = result.substring(1);
    }

    result = phoneMask(maskService, result);
  }

  if (result?.startsWith(`+`)) {
    result = result.substring(1, result.length);
  }
  if (result?.startsWith(`55`)) {
    result = result.substring(2, result.length);
  }
  result = result?.trim();
  return result;
}

export const phoneMask = (maskService: any, phone: string): any => {
  if (phone) {
    const is0800 = phone.substring(2).startsWith('0800') || phone.startsWith('0800');
    const isBr = phone.startsWith('55') && phone.length >= 12;
    if (isBr) {
      if (phone.length === 13) {
        if (is0800) {
          return maskService.applyMask(phone, '+00 0000 000 0000');
        }
        return maskService.applyMask(phone, '+00 (00) 0 0000-0000');
      } else if (phone.length === 12) {
        return maskService.applyMask(phone, '+00 (00) 0000-0000');
      } else if (phone.length === 11) {
        if (is0800) {
          return maskService.applyMask(phone, '0000 000 0000');
        }
        return maskService.applyMask(phone, '(00) 0 0000-0000');
      } else if (phone.length === 10) {
        return maskService.applyMask(phone, '(00) 0000-0000');
      }
    } else {
      return phone.startsWith('+') ? phone : '+' + phone;
    }
  }

  return phone;
};

export const sort_by = (list_of_arguments) => {
  let default_cmp = function (pA, pB) {
    let a = typeof pA === 'string' ? pA.toLowerCase() : pA;
    let b = typeof pB === 'string' ? pB.toLowerCase() : pB;

    if (!isEmpty(a) && typeof a.localeCompare === 'function') return a.localeCompare(b);

    if (a == b) return 0;
    return a < b ? -1 : 1;
  };

  function getCmpFunc(primer, reverse) {
    var dfc = default_cmp, // closer in scope
      cmp = default_cmp;
    if (primer) {
      cmp = function (a, b) {
        return dfc(primer(a), primer(b));
      };
    }
    if (reverse) {
      return function (a, b) {
        return -1 * cmp(a, b);
      };
    }
    return cmp;
  }

  let fields: any[] = [];
  let n_fields: number = list_of_arguments.length;
  let field: any;
  let name: string;
  let cmp: any;

  // preprocess sorting options
  for (let i = 0; i < n_fields; i++) {
    field = list_of_arguments[i];
    if (typeof field === 'string') {
      name = field;
      cmp = default_cmp;
    } else {
      name = field.name;
      cmp = getCmpFunc(field.primer, field.reverse);
    }
    fields.push({ name, cmp });
  }

  // final comparison function
  return function (A, B) {
    var name, result;

    for (var i = 0; i < n_fields; i++) {
      result = 0;
      field = fields[i];
      name = field.name;

      result = field.cmp(A[name], B[name]);
      if (result !== 0) break;
    }

    return result;
  };
};
